function setCSSVars() {
  const header = document.querySelector('[data-site-header]');
  const container = document.querySelector('.page-width');
  const cartFooter = document.querySelector('.drawer__footer');
  const announcement = document.querySelector('.announcement-bar');
  const hero = document.querySelector('.main-hero');
  const ymm = document.querySelector('.easysearch-main-widget');

  const headerHeight = header?.offsetHeight || 150;
  const windowHeight = window.innerHeight;
  const halfPageOffset = container?.offsetLeft || 0;
  const cartFooterHeight = cartFooter?.offsetHeight || 0;
  const announcementHeight = announcement?.offsetHeight || 40;
  const heroHeight = hero?.offsetHeight || 0;
  const ymmHeight = ymm?.offsetHeight || 0;

  document.documentElement.style.setProperty(
    '--window-height',
    `${windowHeight}px`
  );
  document.documentElement.style.setProperty(
    '--header-height',
    `${headerHeight}px`
  );
  document.documentElement.style.setProperty(
    '--half-page-offset',
    `${halfPageOffset}px`
  );
  document.documentElement.style.setProperty(
    '--cart-footer-height',
    `${cartFooterHeight}px`
  );
  document.documentElement.style.setProperty(
    '--announcement-height',
    `${announcementHeight}px`
  );

  document.documentElement.style.setProperty(
    '--ymm-height',
    `${ymmHeight}px`
  );

    document.documentElement.style.setProperty(
    '--hero-height',
    `${heroHeight}px`
  );
}

// Initial set
setCSSVars();

// Responsive updates
window.addEventListener('resize', debounce(setCSSVars, 100));
window.addEventListener(
  'scroll',
  debounce(() => {
    const header = document.querySelector('[data-site-header]');
    const headerHeight = header?.offsetHeight || 150;
    document.documentElement.style.setProperty(
      '--header-height',
      `${headerHeight}px`
    );
  }, 50)
);

const siteHeader = document.querySelector('[data-site-header]');

if (siteHeader) {
  function fixHeader() {
    const scroll = window.scrollY;

    if (scroll > 0) {
      siteHeader.classList.add('scrolling');
    } else {
      siteHeader.classList.remove('scrolling');
    }
  }

  window.addEventListener('scroll', debounce(fixHeader, 50));
  window.addEventListener('resize', debounce(fixHeader, 50));
  window.addEventListener('load', fixHeader);
}


/***************** TOGGLES *******************/
document.addEventListener('click', (event) => {
  if (event.target.dataset.toggleTarget) {
    console.log('toggle');
    slideToggle(event);
  }
  if (event.target.dataset.tabTarget) {
    console.log('tab');
    tabToggle(event);
  }
});

/***************** SLIDE TOGGLES *******************/
function slideToggle(event) {
  console.log('slider toggle');
  const toggles = document.querySelectorAll('[data-toggle-target]');
  const targets = document.querySelectorAll('[data-toggle-content]');
  const target = event.target.dataset.toggleTarget;
  console.log(target, 'TARGET');
  const toggleContainer = document.querySelectorAll(
    `[data-toggle-content="${target}"]`
  );

  console.log(toggleContainer);

  toggleContainer.forEach((group) => {
    if (!group.classList.contains('active')) {
      group.classList.add('active');
      group.style.height = 'auto';
      const height = group.offsetHeight + 'px';
      group.style.height = '0px';
      setTimeout(function () {
        group.style.height = height;
      }, 0);
      group.addEventListener(
        'transitionend',
        function () {
          console.log('transition end');
          group.style.height = 'auto';
        },
        {
          once: true,
        }
      );
    } else {
      group.style.height = 'auto';
      const height = group.offsetHeight + 'px';
      console.log(height, 'height');
      group.style.height = height;
      setTimeout(function () {
        group.style.height = height;
        group.classList.remove('active');
        console.log('remove active', group);
      }, 0);
      group.addEventListener(
        'transitionend',
        function () {
          console.log('transition end');
          group.style.height = '0px';
        },
        {
          once: true,
        }
      );
    }
  });
  // FOR RESETTING ALL ITEMS
  toggles.forEach((toggle) => {
    if (
      (toggle.dataset.toggleTarget == target) &
      toggle.classList.contains('active')
    ) {
      toggle.classList.remove('active');
    } else {
      toggle.classList.add('active');
    }

    if (toggle.dataset.toggleTarget != target) {
      toggle.classList.remove('active');
    }
  });

  targets.forEach((toggle) => {
    if (toggle.dataset.toggleContent != target) {
      toggle.classList.remove('active');
    }
  });
}

/*************** TAB TOGGLES ***********/
function tabToggle(event) {
  event.preventDefault();
  const target = event.target.dataset.tabTarget;
  const tabGroup = event.target.dataset.tabGroup;
  const tabGroups = document.querySelectorAll(`[data-tab-group="${tabGroup}"]`);
  tabGroups.forEach((group) => {
    group.classList.remove('active');
  });
  event.target.classList.add('active');
  document
    .querySelectorAll(
      `[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`
    )
    .forEach((group) => {
      group.classList.add('active');
    });
}

// MODAL TOGGLING
document.querySelectorAll('[data-modal-target]').forEach((btnOpen) => {
  btnOpen.onclick = function (event) {
    const target = btnOpen.dataset.modalTarget;
    const modalContent = document.querySelector(
      `[data-modal-content="${target}"]`
    );
    const closeModal = modalContent.querySelector('[data-close]');
    const modalSlider = modalContent.querySelector('.bd-slider');

    event.preventDefault();
    console.log('open modal');
    modalContent.classList.add('active');

    document.querySelector('body').classList.add('overflow-hidden');
    closeModal.onclick = function () {
      //  console.log('close modal');
      modalContent.classList.remove('active');
      document.querySelector('body').classList.remove('overflow-hidden');
    };
    window.onclick = function (event) {
      // console.log(event);
      if (event.target == modalContent) {
        // console.log('close modal');

        modalContent.classList.remove('active');
        document.querySelector('body').classList.remove('overflow-hidden');
      }
    };
    window.addEventListener('keyup', function (e) {
      if (e.code === 'Escape') {
        modalContent.classList.remove('active');
        document.querySelector('body').classList.remove('overflow-hidden');
      }
    });

    if (modalSlider) {
      const slider = new slick(modalSlider);
      console.log('resize slider');
      slider.resize();
    }
  };
});

/************ Smooth Scroll  ****************/

document
  .querySelectorAll('a[href*="#"]:not([href="#"], .no-scroll)')
  .forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      const offset = headerHeight() * -2;
      if (
        location.pathname.replace(/^\//, '') ==
          this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        let target = anchor.hash;
        target = target.length
          ? target
          : document.querySelector(`[name="${this.hash.slice(1)}"]`);

        if (target.length) {
          window.scrollTo({
            top:
              document.getElementById(target.replace('#', '')).offsetTop +
              offset,
            left: 0,
            behavior: 'smooth',
          });
        }
      }
    });
  });
// RANGE SLIDERS

function createRangeSliders() {
  let rangeMin = 0;
  document.querySelectorAll('[data-range-container]').forEach((ranger) => {
    //console.log(ranger, 'ranger');
    const rangeInput = ranger.querySelectorAll('[data-range-slider] input');
    const rangePrice = ranger.querySelectorAll('[data-range-prices] input');
    const range = ranger.querySelector('[data-range-selected]');
    // console.log('range', range);
    function getPosition(rangeInput, rangePrice, range) {
      let minRange = parseInt(rangeInput[0].value);
      let maxRange = parseInt(rangeInput[1].value);
      if (maxRange - minRange < rangeMin) {
        if (e.target.className === 'min') {
          rangeInput[0].value = maxRange - rangeMin;
        } else {
          rangeInput[1].value = minRange + rangeMin;
        }
      } else {
        rangePrice[0].value = minRange;
        rangePrice[1].value = maxRange;
        range.style.left = (minRange / rangeInput[0].max) * 100 + '%';
        range.style.right = 100 - (maxRange / rangeInput[1].max) * 100 + '%';
      }
    }
    rangeInput.forEach((input) => {
      getPosition(rangeInput, rangePrice, range);
      input.addEventListener('input', () => {
        getPosition(rangeInput, rangePrice, range);
      });
    });

    rangePrice.forEach((input) => {
      input.addEventListener('input', (e) => {
        let minPrice = rangePrice[0].value;
        let maxPrice = rangePrice[1].value;
        if (maxPrice - minPrice >= rangeMin && maxPrice <= rangeInput[1].max) {
          if (e.target.className === 'min') {
            rangeInput[0].value = minPrice;
            range.style.left = (minPrice / rangeInput[0].max) * 100 + '%';
          } else {
            rangeInput[1].value = maxPrice;
            range.style.right =
              100 - (maxPrice / rangeInput[1].max) * 100 + '%';
          }
        }
      });
    });
  });
}

/** VARIANT SELECTS DISABLE ADD TO **/

document.querySelectorAll('variant-selects').forEach((dropdown) => {
  const selects = dropdown.querySelectorAll('select');
  const formId = selects[0].getAttribute('form');
  const values = Array.from(selects).map((el) => el.value);
  console.log(formId);
  console.log(values);

  function checkAvailability(arr, val) {
    return arr.some((arrVal) => val === arrVal);
  }
  if (checkAvailability(values, 'no-option')) {
    document
      .querySelector(`#${formId}`)
      .parentElement.classList.add('disabled');
  } else {
    document
      .querySelector(`#${formId}`)
      .parentElement.classList.remove('disabled');
  }
  selects.forEach((input) => {
    input.addEventListener('change', (e) => {
      const values = Array.from(selects).map((el) => el.value);
      console.log('select change', e);
      if (checkAvailability(values, 'no-option')) {
        document
          .querySelector(`#${formId}`)
          .parentElement.classList.add('disabled');
      } else {
        document
          .querySelector(`#${formId}`)
          .parentElement.classList.remove('disabled');
        console.log(input, 'disable no value');
        input.querySelector('[data-no-option]').setAttribute('disabled', true);
      }
    });
  });
});
